// src/components/chat/BlockReferenceAttachment.tsx
// Renders an inline indicator in chat messages when the agent has added
// a block to the dashboard canvas.

import React from 'react';
import { LayoutDashboard } from 'lucide-react';

interface BlockReferenceAttachmentProps {
  blockId: string;
}

const BlockReferenceAttachment: React.FC<BlockReferenceAttachmentProps> = () => (
  <div className="rounded-lg border border-primary/50 bg-accent/50 px-3 py-2 inline-flex items-center gap-2">
    <LayoutDashboard className="w-3.5 h-3.5 text-primary" />
    <span className="text-xs text-primary">
      Block added to canvas
    </span>
  </div>
);

export default BlockReferenceAttachment;
